// Rewrite - make all strings below constants somewhere
import store from "../../../store";

// Actions Import
import PricebooksActions from "../../../actions/PricebooksActions";

import { PRICEBOOK } from "../../../constants";
import { GlobalUtils } from "../../../utils";

// Destructuring
const { NOT_APPLICABLE_WRT_CHARGETYPE_MAP: NA_CHARGETYPE_MAP } = PRICEBOOK;
const { twoArrayLookUp } = GlobalUtils;
const { updateFormRowDataField, updatePbItemEditorRequiredFields } =
  PricebooksActions;

const notApplicableWrtChargeType = (chargeType, fieldName) => {
  if (chargeType === "") {
    return true;
  }
  if (NA_CHARGETYPE_MAP[fieldName].includes(chargeType)) {
    return true;
  }
  return false;
};

const updateRequiredFields = (fieldName, keepFieldName) => {
  const reduxState = store.getState();
  const { pbItemEditorRequiredFields } = reduxState.PricebookStore;
  const tempFields = [...pbItemEditorRequiredFields];

  if (
    (keepFieldName && !tempFields.includes(fieldName)) ||
    (!keepFieldName && tempFields.includes(fieldName))
  ) {
    // tempFields = [...tempFields, fieldName];
    store.dispatch(updatePbItemEditorRequiredFields(fieldName, keepFieldName));
  }
  // if (!keepFieldName && tempFields.includes(fieldName)) {
  //   tempFields = tempFields.filter(item => item !== fieldName);
  // }
};

// Custom JSON manipulator for screen 1
// eslint-disable-next-line import/prefer-default-export
export const manipulateCustomJSONOne = (
  customJSON,
  isEdit,
  formRowData,
  fieldMapIndex,
  products,
  unusedProducts,
) => {
  let tempJSON = [...customJSON];
  const currentChargeType = formRowData[fieldMapIndex.charge_type];
  // to hide Products select and add a disabled input for it in case of edit

  // const productIndex = tempJSON.findIndex(item => item.name === "product");
  // if (isEdit) {
  //   tempJSON[productIndex] = { ...tempJSON[productIndex], visibility: false };
  // }
  const productSkuField = {
    label: "Product SKU",
    name: "productSKU",
    type: "text",
    required: false,
    standard: true,
    defaultVal: "",
    span: "half",
    visibility: true,
    order: 0,
    applicable: true,
    disabled: true,
    dummyField: true,
  };
  const productCodeField = {
    label: "Product Code",
    name: "productCode",
    type: "text",
    required: false,
    standard: true,
    defaultVal: "",
    span: "half",
    visibility: true,
    order: 0,
    applicable: true,
    disabled: true,
    dummyField: true,
  };
  const productConfigField = {
    label: "Product Configuration",
    name: "productConfig",
    type: "text",
    required: false,
    standard: true,
    defaultVal: "",
    span: "half",
    visibility: true,
    order: 0,
    applicable: true,
    disabled: true,
    dummyField: true,
  };
  tempJSON = [
    ...tempJSON.slice(0, 1),
    productSkuField,
    productCodeField,
    productConfigField,
    ...tempJSON.slice(1),
  ];

  let productIsAResource = false;
  if (formRowData[fieldMapIndex.product]) {
    const selectedProduct = twoArrayLookUp(
      products,
      unusedProducts,
      formRowData[fieldMapIndex.product],
    );
    if (
      selectedProduct.type === "Resource" ||
      selectedProduct.type === "On shore resource" ||
      selectedProduct.type === "Off shore resource"
    ) {
      productIsAResource = true;
    } else {
      productIsAResource = false;
    }
  }

  /**
   * change Charge Frequency - "charge_frequency"
   */
  const chargeFrequencyIndex = tempJSON.findIndex(
    item => item.name === "charge_frequency",
  );
  const tempChargeFrequencyObj = { ...tempJSON[chargeFrequencyIndex] };
  // charge_type rules
  if (notApplicableWrtChargeType(currentChargeType, "charge_frequency")) {
    tempChargeFrequencyObj.applicable = false;
    tempChargeFrequencyObj.required = false;
    updateRequiredFields("charge_frequency", false);
  } else {
    tempChargeFrequencyObj.applicable = true;
    tempChargeFrequencyObj.required = true;
    updateRequiredFields("charge_frequency", true);
    // if productIsAResource Recurring Period should be disabled
    if (productIsAResource) {
      tempChargeFrequencyObj.disabled = true;
      if (formRowData[fieldMapIndex.charge_frequency] !== "Monthly") {
        store.dispatch(
          updateFormRowDataField(fieldMapIndex.charge_frequency, "Monthly"),
        );
      }
    } else {
      tempChargeFrequencyObj.disabled = false;
    }
  }
  tempJSON[chargeFrequencyIndex] = tempChargeFrequencyObj;

  /**
   * change Minimum Selling Term - "selling_term"
   */
  const sellingTermIndex = tempJSON.findIndex(
    item => item.name === "selling_term",
  );
  const tempSellingTermObj = { ...tempJSON[sellingTermIndex] };
  // charge_type rules
  if (notApplicableWrtChargeType(currentChargeType, "selling_term")) {
    tempSellingTermObj.applicable = false;
    tempSellingTermObj.required = false;
    updateRequiredFields("selling_term", false);
  } else {
    tempSellingTermObj.applicable = true;
    tempSellingTermObj.required = true;
    updateRequiredFields("selling_term", true);
  }
  tempJSON[sellingTermIndex] = tempSellingTermObj;

  /**
   * change Selling Term UoM - "recurring_period"
   */
  const recurringPeriodIndex = tempJSON.findIndex(
    item => item.name === "recurring_period",
  );
  const tempRecurringPeriodObj = { ...tempJSON[recurringPeriodIndex] };

  // charge_type rules
  if (notApplicableWrtChargeType(currentChargeType, "recurring_period")) {
    tempRecurringPeriodObj.applicable = false;
    tempRecurringPeriodObj.required = false;
    updateRequiredFields("recurring_period", false);
  } else {
    tempRecurringPeriodObj.applicable = true;
    tempRecurringPeriodObj.required = true;
    updateRequiredFields("recurring_period", true);
    // if productIsAResource Recurring Period should be disabled
    if (productIsAResource) {
      tempRecurringPeriodObj.disabled = true;
      if (formRowData[fieldMapIndex.recurring_period] !== "Monthly") {
        store.dispatch(
          updateFormRowDataField(fieldMapIndex.recurring_period, "Monthly"),
        );
      }
    } else {
      tempRecurringPeriodObj.disabled = false;
    }
  }
  tempJSON[recurringPeriodIndex] = tempRecurringPeriodObj;

  /**
   * change Max Usage - "max_usage" & Usage UOM - "max_usage_uom"
   */
  const maxUsageIndex = tempJSON.findIndex(item => item.name === "max_usage");
  const tempMaxUsageObj = { ...tempJSON[maxUsageIndex] };
  const maxUsageUomIndex = tempJSON.findIndex(
    item => item.name === "max_usage_uom",
  );
  const tempMaxUsageUomObj = { ...tempJSON[maxUsageUomIndex] };
  // charge_type rules
  if (notApplicableWrtChargeType(currentChargeType, "max_usage")) {
    tempMaxUsageObj.applicable = false;
    tempMaxUsageUomObj.applicable = false;
  } else {
    tempMaxUsageObj.applicable = true;
    tempMaxUsageUomObj.applicable = true;
  }
  tempJSON[maxUsageIndex] = tempMaxUsageObj;

  if (
    formRowData[fieldMapIndex.max_usage] > 0 &&
    formRowData[fieldMapIndex.max_usage] !== ""
  ) {
    tempMaxUsageUomObj.disabled = false;
  } else {
    tempMaxUsageUomObj.disabled = true;
  }
  tempJSON[maxUsageUomIndex] = tempMaxUsageUomObj;

  return tempJSON;
};
